import React, { FC, useState, useEffect } from 'react';
import { Box, Stack, RadioGroup, Typography } from '@mui/material';
import TwAutocomplete from '../TwAutocomplete/TwAutocomplete';
import { Driver } from '../../redux/api/driver/driver.model';
import './TwNotifyDriver.scss';
import { INotifyDriverWithFullSegment } from './TwNotifyDriver';
import CloseIcon from '@mui/icons-material/Close';
import useDriverSelection from './hooks/useDriverSelection';
import NotificationMethodSelector from './NotificationMethodSelector';
import DriverLinkCopy from './DriverLinkCopy';
import TwExpandableTextarea from '../TwExpandableTextArea/TwExpandableTextArea';

interface INotifySegmentBody {
  driver: INotifyDriverWithFullSegment;
  driverLink: string | null;
  driversList: Driver[];
  handleUpdateDriver: (
    id: string,
    radio: string,
    segmentId: string,
    removed: boolean,
    oldDriverId?: string,
    driverName?: string,
    deletedSegmentIndex?: number,
    textMessage?: string
  ) => void;
  allowRemove: boolean;
}

const NotifySegmentsBody: FC<INotifySegmentBody> = ({
  driver,
  driverLink,
  driversList,
  handleUpdateDriver,
  allowRemove
}) => {
  const {
    selectedDriverOption,
    selectedDriver,
    radio,
    setRadio,
    driversListOptions,
    handleDriverChange,
    textMessage,
    handleTextMessageChange
  } = useDriverSelection({
    driver,
    driversList,
    handleUpdateDriver
  });

  return (
    <>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <TwAutocomplete
          id="driver"
          name="driver"
          value={selectedDriverOption || null}
          optionList={driversListOptions}
          disabled={true}
        />
        {allowRemove && (
          <CloseIcon
            className="invoice-items__remove"
            onClick={(): void => {
              handleDriverChange(selectedDriverOption, true, selectedDriverOption?.id);
            }}
          />
        )}
      </Box>

      <Stack
        spacing={3}
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        width="100%"
        className="notify-driver__send-options"
      >
        <NotificationMethodSelector
          hasPhoneContactInfo={!!selectedDriver?.phone}
          hasEmailContactInfo={!!selectedDriver?.email_address}
          radio={radio}
          onRadioChange={(value): void => {
            setRadio(value);
            handleUpdateDriver(
              selectedDriverOption?.id || '',
              value,
              driver.fullSegment.id || '',
              false
            );
          }}
        />
        <DriverLinkCopy driverLink={driverLink} />
      </Stack>

      {radio === 'phone' && (
        <Box sx={{ marginTop: '10px' }}>
          <TwExpandableTextarea
            name="message"
            id="message"
            label="Message"
            maxCharacters={320}
            thresholdCount={160}
            maxRows={5}
            warningMessage="SMS messages over 160 characters will be split into multiple messages"
            onInputChange={(e): void => {
              handleTextMessageChange(e.target.value);
            }}
            value={textMessage}
          />
        </Box>
      )}
    </>
  );
};

export default NotifySegmentsBody;
